import { NavItem, SubnavItem, additionalRoutes, navbar } from 'configs/navbar'
import { NextRouter } from 'next/router'

export const navItemIsActive = (nav: NavItem | SubnavItem, router: NextRouter): boolean => {
  return nav.active
    .filter((p) => p !== '')
    .some((p) => router.asPath.includes(p.slice(0, p.length - 1)))
}

export const findActiveNavItem = (router: NextRouter) => {
  return navbar
    .concat(additionalRoutes)
    .flatMap((item) => item.items)
    .find((item) =>
      item.active
        .filter((p) => p !== '')
        .some((p) => router.asPath.includes(p.slice(0, p.length - 1)))
    )
}
